import React, { useState } from 'react';
import { Checkbox } from '@deere/ux.uxframe-react';
import Button from '@material-ui/core/Button';
import GetAppIcon from '@material-ui/icons/GetApp';
import { DeereFetch } from '../../../shared/fetch';
import { SpinnerIcon } from '../../Icon';
import PropTypes from 'prop-types';

const DocumentRow = ({countryCode, documentName, documentCode, documentSigners, financeProduct, quoteNumber, getSelected}) => {
    const [downloading, setDownloading] = useState(false);
    const [downloadError, setDownloadError] = useState(false);

    async function downloadPdfFile() {
        setDownloading(true);
        setDownloadError(false);
        try {
            const pdfDocData = await DeereFetch(`/api/quotes/documents/${quoteNumber}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                },
                body: JSON.stringify({
                    'code': documentCode,
                    'country': countryCode,
                    'description': documentName,
                    'financeProduct': financeProduct
                })
            });
            const pdfText = 'data:application/pdf;base64,' + pdfDocData.dataHandler;
            const link = document.createElement('a');
            document.body.appendChild(link);
            link.href = pdfText;
            link.download = pdfDocData.filename;
            link.click();
            link.remove();
        } catch (err) {
            setDownloadError(true);
        } finally {
            setDownloading(false);
        }
    }

    function handleChange(e) {
        getSelected(e.target.checked, documentCode, documentName, documentSigners)
    }

    return (
        <tr>
            <td className="text-center">
                <Checkbox
                    id={'checkbox-' + documentCode}
                    onChange={e => handleChange(e)}
                />
            </td>
            <td>{documentName}</td>
            <td className="text-center">
                {
                    downloading ?
                        <SpinnerIcon size="sm"/> :
                        <div>
                            <Button
                                onClick={() => downloadPdfFile()}
                                size="small"
                                style={{margin: 'auto'}}
                                title="Download">{<GetAppIcon/>}</Button>
                            {
                                downloadError &&
                                <div className="text-danger font-weight-normal" style={{fontSize: '12px'}}>
                                    Unable to download.
                                </div>
                            }
                        </div>
                }
            </td>
        </tr>
    )
};

DocumentRow.propTypes = {
    countryCode: PropTypes.string.isRequired,
    documentName: PropTypes.string.isRequired,
    documentCode: PropTypes.string.isRequired,
    documentSigners: PropTypes.arrayOf(PropTypes.string),
    financeProduct: PropTypes.string.isRequired,
    quoteNumber: PropTypes.string.isRequired,
    getSelected: PropTypes.func
};

export default DocumentRow;
